<div class="user-groups-container">
  <div class="section-header d-flex">
    <span>{{localisedUserGroups}}</span>
    <app-button-transparent
      (clicked)="openManageGroupsModal()"
      [text]="T.common.manage_groups | translate"
      class="ml-auto"
      *ngIf="canEdit"
    ></app-button-transparent>
  </div>
  <div class="mt-24">
    <ng-container *ngFor="let group of groups; let i = index">
      <span class="underline">{{group.title}}</span> <span *ngIf="i < groups.length - 1">;</span>
    </ng-container>
  </div>
</div>
